import React from "react";
import moment from "moment";
import CommonMonthDayYearPicker from "../../common/MonthDayYearPicker";

export default function MonthDayYearInput({
  value,
  onSubmit,
  disabled,
  label = "MM/DD/YYYY",
  submitFormat,
}) {
  const handleChange = nextValue => {
    if (!submitFormat || !nextValue || nextValue === "N/A") {
      onSubmit(nextValue);
      return;
    }

    const date = moment(nextValue, "MM/DD/YYYY", true);
    onSubmit(date.isValid() ? date.format(submitFormat) : nextValue);
  };

  return (
    <CommonMonthDayYearPicker
      value={value}
      onChange={handleChange}
      disabled={disabled}
      label={label}
      autoOpen
    />
  );
}
